import {useState, useEffect} from 'react';
import {onNetworkStatusChange} from '../services/api';

export function useNetworkStatus(): boolean {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    // Also subscribe to api.ts network status (catches server-unreachable-but-WiFi-connected)
    const unsubApi = onNetworkStatusChange(setIsOnline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
      unsubApi();
    };
  }, []);

  return isOnline;
}
